import { render, staticRenderFns } from "./dialog-backup-status.vue?vue&type=template&id=6f889996"
import script from "./dialog-backup-status.vue?vue&type=script&lang=js"
export * from "./dialog-backup-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports